import { DefaultTheme } from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

/**
 * New look: member statuses as theme colours (the classic look keeps the
 * antd palette). Green for an active member, red for one who shouldn't be in
 * the group, orange for removed or inactive ones, yellow while pending.
 */
export const getMemberStatusColor = (
  theme: DefaultTheme,
  displayName?: string
) => {
  const tokens = getNewLookTokens(theme);
  switch (displayName) {
    case "users.statuses.active":
      return tokens.up;
    case "users.statuses.expiredInGroup":
    case "users.statuses.unauthorized":
      return tokens.down;
    case "users.statuses.pending":
      return theme.colors.yellow;
    default:
      return tokens.stop;
  }
};
